/**
 * Ensures all Swiper slides match the tallest slide by auto-calculating
 * and applying uniform min-height.
 */
class SwiperSlideHeightManager {
  constructor(selector = '.products-list.swiper-wrapper') {
    this.selector = selector;
    this.slideSelector = '.swiper-slide';

    this.init();
  }

  init() {
    this.waitForSwiper(() => {
      this.fixHeights();
      this.retryHeights();   // handles late-loaded content
      this.attachResize();
    });
  }

  waitForSwiper(callback) {
    const timer = setInterval(() => {
      const wrapper = document.querySelector(this.selector);
      const swiperEl = wrapper?.closest('.swiper');

      if (swiperEl && swiperEl.classList.contains('swiper-initialized')) {
        clearInterval(timer);
        callback();
      }
    }, 120);
  }

  async fixHeights() {
    const wrapper = document.querySelector(this.selector);
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll(this.slideSelector);
    if (!slides.length) return;

    // reset for accurate measurement
    slides.forEach(s => {
      s.style.height = 'auto';
      s.style.minHeight = '0';
    });

    // wait for layout & font rendering to stabilize
    await new Promise(r => requestAnimationFrame(() =>
      requestAnimationFrame(r)
    ));

    // get tallest slide
    let max = 0;
    slides.forEach(s => {
      const h = s.scrollHeight;
      if (h > max) max = h;
    });

    if (!max) return;

    // apply MIN-HEIGHT so content can grow and NOT be cut
    slides.forEach(s => {
      s.style.minHeight = `${ max }px`;
      s.style.height = 'auto'; // allow natural height if content grows
    });
  }

  // extra retries help when images or icons load late
  retryHeights() {
    [100, 300, 600].forEach(delay => {
      setTimeout(() => this.fixHeights(), delay);
    });
  }

  attachResize() {
    let timer;
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(() => this.fixHeights(), 200);
    });
  }
}

new SwiperSlideHeightManager();